import { render } from "./HomeTabs.vue?vue&type=template&id=6f45eca7&scoped=true"
import script from "./HomeTabs.vue?vue&type=script&lang=js"
export * from "./HomeTabs.vue?vue&type=script&lang=js"

import "./HomeTabs.vue?vue&type=style&index=0&id=6f45eca7&lang=less&scoped=true"

import exportComponent from "C:\\project\\famous-build-en\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f45eca7"]])

export default __exports__